// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1IUcY","upload":"Small_upload__2oBIm","imageWrap":"Small_imageWrap__35s7t","removeBtn":"Small_removeBtn__2ukfx"};